import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AppStateStore, AppState } from './app-state.store';
import { navigatorOnline$ } from 'projects/core/src/lib/core/utils/core.utils';

@Injectable({
    providedIn: 'root'
})
export class AppStateQuery extends Query<AppState> {
    choosenUser$ = this.select(state => state.choosenUser);
    currentUser$ = this.select(state => state.currentUser);
    userProfile$ = this.select(state => state.userProfile);
    initialized$ = this.select(state => state.initialized);
    authorized$ = this.select(state => state.authorized);
    wsSocketReady$ = this.select(state => state.wsSocketReady);
    userRole$ = this.select(state => state.userRole)
    rolesAccessMap$ = this.select(state => state.rolesAccessMap)
    online$ = navigatorOnline$();

    constructor(protected store: AppStateStore) {
        super(store);
    }
}